<template>
  <div class="vacancy-basic">
    <vtitle />

    <vmodules
      v-if="modules.length"
      type="vacancy"
      :label="$tr('vacancy.basic.form.modules.label')"
      :modules="enabledModules"
      @toggle="set_is_active"
    />

    <settings :modules="enabledModules" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import vmodules from '@/routes_new/inner/vacancy/basic/components/vmodules';
import vtitle from '@/routes_new/inner/vacancy/components/vtitle';
import Settings from '@/routes_new/inner/vacancy/basic/components/settings';

export default {
  name: 'VacancyBasicDefault',

  components: {
    Settings,
    vmodules,
    vtitle
  },

  computed: {
    ...mapState('vacancy_new', { vacancy: 'item' }),

    ...mapState('vacancy_new/modules', { modules: 'list' }),

    enabledModules() {
      return this.modules.filter(item => item.is_enabled);
    }
  },

  methods: {
    ...mapActions('vacancy_new/modules', ['save']),

    set_is_active(params) {
      if (params.value === false) {
        let modules = this.modules.filter(i => i.is_active === true);

        if (modules.length === 1) {
          this.$noty.error(this.$tr('vacancy.basic.form.modules.informers.cant_deactivate'));
          return false;
        }
      }

      let data = {};

      data.vacancy_id = this.vacancy.id;
      data.value = { id: params.id, is_active: params.value };

      this.save(data)
        .then(() => {
          this.$noty.success(this.$tr('vacancy.basic.form.modules.test.informers.save_success'));
        })
        .catch(() => {
          this.$noty.error(this.$tr('common.error.networkError'));
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.vacancy-basic {
  max-width: 500px;
}
</style>
